module.exports = __webpack_public_path__ + "img/blue-tab.0cc1ba39.svg";